import React, { useState } from 'react'

import classes from "./Input1.module.css";

const Input1 = React.forwardRef((props, ref) => {
    // password fields get a show/hide 'eye' toggle
    const isPassword = props.type === "password";
    const [showPassword, setShowPassword] = useState(false);

    const input = (
        <input
            className={`${classes.input} ${isPassword ? classes.passwordInput : ''}`}
            placeholder={props.placeholder}
            ref={ref}
            id={props.id}
            type={isPassword && showPassword ? "text" : props.type}
            isValid={props.isValid}
            value={props.value}
            onChange={props.onChange}
            onBlur={props.onBlur}
        />
    );

    if (!isPassword) {
        return input;
    }

    return (
        <div className={classes.passwordWrapper}>
            {input}
            <button
                type="button"
                className={classes.visibilityToggle}
                onClick={() => setShowPassword(prev => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
            >
                <i className={showPassword ? "pi pi-eye-slash" : "pi pi-eye"} />
            </button>
        </div>
    );
});

export default Input1
